import { getRndStr } from '@repo/common-utils/utils/utils'
import { getBaseUrl } from '@repo/common-utils/utils/url'
import { post } from '@repo/http/http'
import {
  RND_KEY,
  SESSION,
  HAS_EXTEND_PROCESS_KEY,
  LOGINTIME_KEY,
  HAS_EXTEND_PROCESS_VALUE,
  HAS_NO_EXTEND_PROCESS_VALUE,
} from '@repo/common-utils/constants/user'
import { isInOutsideH5 } from '@fs/utils'
import debounce from 'lodash/debounce'

const { VUE_APP_UC = '' } = import.meta.env
const baseUrl = getBaseUrl(VUE_APP_UC)
const LoginSessionExtend = (data) => {
  return post(`${baseUrl}/uc/v1/SessionExtend`, { data })
}

export const EsopLoginSessionExtend = (data) => {
  return post(`${baseUrl}/uc/esop/v1/SessionExtend`, { data })
}

const SessionExtendFunc = async (isEsop) => {
  try {
    const rndkey = getRndStr(32)
    const { data } = isEsop
      ? await EsopLoginSessionExtend({ rndkey })
      : await LoginSessionExtend({ rndkey })
    localStorage.setItem(RND_KEY, rndkey)
    localStorage.setItem(SESSION, data?.result?.session)
    localStorage.setItem(LOGINTIME_KEY, new Date().getTime())
    localStorage.setItem(HAS_EXTEND_PROCESS_KEY, HAS_NO_EXTEND_PROCESS_VALUE)
  } catch {
    localStorage.setItem(HAS_EXTEND_PROCESS_KEY, HAS_NO_EXTEND_PROCESS_VALUE)
  }
}

export function extendSessionLogic(response) {
  if (isInOutsideH5()) {
    const isLoginExceedTenMinutes =
      new Date().getTime() - localStorage.getItem(LOGINTIME_KEY) > 10 * 60 * 1000
    const isHasExtendprocess =
      localStorage.getItem(HAS_EXTEND_PROCESS_KEY) === HAS_EXTEND_PROCESS_VALUE
    const excludeInterfaceArr = [
      '/uc/v1/WebIPLocationGet',
      '/uc/v1/WebCodeSend',
      '/uc/v1/CodeSend',
      '/uc/v1/CodeVerify',
      '/uc/v1/LoginWeb',
      '/uc/v1/LoginSms',
      '/uc/v1/SessionExtend',
    ]
    const requestUrl = response.config.url
    const isEsopUrl = requestUrl.includes('/esop/')
    const isNeedExtend = excludeInterfaceArr.every((item) => !requestUrl.includes(item))
    console.log('response.config.url', requestUrl)
    const isLogin =
      localStorage.getItem(SESSION) && localStorage.getItem(RND_KEY) && localStorage.getItem('uin')
    if (isLoginExceedTenMinutes && isNeedExtend && !isHasExtendprocess && isLogin) {
      // 设置标志位，保证第一个业务接口调用展期接口后，后续业务接口不重复调用展期接口
      localStorage.setItem(HAS_EXTEND_PROCESS_KEY, HAS_EXTEND_PROCESS_VALUE)
      debounce(() => SessionExtendFunc(isEsopUrl), 3000)()
    }
  }
}

// http库注册拦截器使用
export default (response) => {
  extendSessionLogic(response)
  return response
}
